var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useEffect, useRef } from 'react';
import { ReactFlow, Background, useReactFlow, addEdge, useNodesState, useEdgesState, applyNodeChanges, useOnSelectionChange, } from 'reactflow';
import 'reactflow/dist/style.css';
import { PatchWidget } from 'containers/StructureBuilderPage/PatchWidget/PatchWidget';
import './Graph.css';
import { changeAddPatchModalState, changeCreateCustomLogicModalState, changeFilterPopUpState, changeSearchPatchState, setDeleteConfirmationState, updateModalPosition, } from 'store/structureBuilderUI/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { setCareerSourceAction } from 'store/structureBuilderCarrer/actions';
import { FloatingMenu } from './FloatingMenu';
import { selectCreateCustomLogicModalState, selectDeleteConfirmationState, selectSearchModalState, } from 'store/structureBuilderUI/selectors';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { getModalPosition, isReadOnlyCanvas } from './PatchWidget/helpers';
import { ContextMenu } from './ContextMenu';
import { CreateCustomLogicModal } from './CreateCustomLogicModal';
import { SearchModal } from './SearchModal';
import { ShortCutModal } from './ShortCutModal';
import { ShortCutButton } from './ShortCutButton';
import { pruneSelectedPatchIds, deselectAllNodes, selectOnlyEdge, } from './utils';
import { useCloseOnRouteChange } from 'utils/hooks/closeOnRouteChange';
var nodeTypes = {
    view: PatchWidget,
    list: PatchWidget,
    logic: PatchWidget,
    navigation: PatchWidget,
    logic_group: PatchWidget,
};
var NAVIGATION_NODES = new Set(['view', 'list', 'navigation']);
var PatchworkGraph = function (_a) {
    var _b;
    var appId = _a.appId, onPatchSelected = _a.onPatchSelected, onDeselect = _a.onDeselect, onPatchDelete = _a.onPatchDelete, onEdgeAdded = _a.onEdgeAdded, onEdgeSelected = _a.onEdgeSelected, onEdgeDelete = _a.onEdgeDelete, onRefreshPatchwork = _a.onRefreshPatchwork, permissions = _a.permissions, pushTemplates = _a.pushTemplates, patchesConnectedToHome = _a.patchesConnectedToHome, onCopy = _a.onCopy, onPaste = _a.onPaste, patchwork = _a.patchwork, openGroup = _a.openGroup, onCreateCustomLogicPatchWithLogicPatches = _a.onCreateCustomLogicPatchWithLogicPatches, groupSelected = _a.groupSelected, onPatchAddNewEvent = _a.onPatchAddNewEvent, onDuplicateBlock = _a.onDuplicateBlock, onRenamePatch = _a.onRenamePatch, onSetEntrypoint = _a.onSetEntrypoint, selectGroup = _a.selectGroup, onChangePatchCoordinates = _a.onChangePatchCoordinates, selectedEntity = _a.selectedEntity, onCursorPosition = _a.onCursorPosition, isFocused = _a.isFocused, focusEntityId = _a.focusEntityId;
    var connectionDetails = useRef(null);
    var reactFlowWrapper = useRef(null);
    var lastFocusedEntityId = useRef(null);
    var _c = useState({}), matchingPatch = _c[0], setMatchingPatch = _c[1];
    var _d = useReactFlow(), screenToFlowPosition = _d.screenToFlowPosition, fitView = _d.fitView;
    var dispatch = useDispatch();
    var isDeleteConfirmationOpen = useSelector(selectDeleteConfirmationState);
    var isModalOpen = useSelector(selectCreateCustomLogicModalState);
    var isSearchModalOpen = useSelector(selectSearchModalState);
    var _e = useState([]), selectedPatches = _e[0], setSelectedPatches = _e[1];
    var _f = useState([]), selectedEdges = _f[0], setSelectedEdges = _f[1];
    var _g = useState(false), isGraphActive = _g[0], setIsGraphActive = _g[1];
    // reactflow requires a memoized handler here — an inline fn re-registers on
    // every render and selection-change events can be missed
    var handleSelectionChange = useCallback(function (_a) {
        var nodes = _a.nodes, edges = _a.edges;
        setSelectedPatches(nodes.map(function (n) { return n.id; }));
        setSelectedEdges(edges.map(function (n) { return n.id; }));
        if (nodes.length === 1) {
            onPatchSelected(nodes.map(function (n) { return n.data.patch; })[0]);
        }
        else {
            ((selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.type) === 'patch' || !selectedEntity) && onDeselect();
        }
    }, [onPatchSelected, onDeselect, selectedEntity]);
    useOnSelectionChange({ onChange: handleSelectionChange });
    var handleNodeDelete = useCallback(function () {
        dispatch(setDeleteConfirmationState(true));
    }, [dispatch]);
    var _h = useNodesState([]), nodes = _h[0], setNodes = _h[1];
    var _j = useEdgesState([]), edges = _j[0], setEdges = _j[1], onEdgesChangeBase = _j[2];
    useEffect(function () {
        setNodes(function (prevNodes) {
            var selectedIds = prevNodes.filter(function (n) { return n.selected; }).map(function (n) { return n.id; });
            return patchwork.patches.map(function (patch) {
                var _a, _b, _c;
                // find existing node if it exists
                var existingNode = prevNodes.find(function (n) { return n.id === patch.id; });
                return {
                    id: patch.id,
                    type: patch.type,
                    position: (_a = existingNode === null || existingNode === void 0 ? void 0 : existingNode.position) !== null && _a !== void 0 ? _a : {
                        x: (_b = patch.x) !== null && _b !== void 0 ? _b : 0,
                        y: (_c = patch.y) !== null && _c !== void 0 ? _c : 0,
                    },
                    selected: selectedIds.includes(patch.id),
                    data: __assign(__assign({}, existingNode === null || existingNode === void 0 ? void 0 : existingNode.data), { patch: patch, entrypoint: patchwork.entrypoint === patch.id, onAddPort: onPatchAddNewEvent, onDuplicate: onDuplicateBlock, onRenamePatch: onRenamePatch, onChangeEntryPoint: onSetEntrypoint, onDelete: handleNodeDelete, onOpenGroup: selectGroup }),
                };
            });
        });
        // selection state can outlive the patches it points at (refetch wipes,
        // deletions) — prune it so stale ids can't drive the delete flow
        setSelectedPatches(function (prev) { return pruneSelectedPatchIds(prev, patchwork.patches); });
    }, [
        patchwork.patches,
        patchwork.entrypoint,
        setNodes,
        onPatchAddNewEvent,
        onDuplicateBlock,
        onSetEntrypoint,
        handleNodeDelete,
        selectGroup,
        onRenamePatch,
    ]);
    useEffect(function () {
        setEdges(function (prevEdges) {
            var selectedEdgeIds = prevEdges.filter(function (e) { return e.selected; }).map(function (e) { return e.id; });
            return patchwork.edges.map(function (edge) {
                var _a;
                var id = (_a = edge.id) !== null && _a !== void 0 ? _a : "".concat(edge.from_patch, "-").concat(edge.to_patch);
                var existing = prevEdges.find(function (e) { return e.id === id; });
                return __assign(__assign({ id: id, source: edge.from_patch, target: edge.to_patch, sourceHandle: edge.from_arg, targetHandle: edge.to_arg }, existing), { 
                    // `selectedEntity` is the parent's selection source of truth; deriving
                    // from it (not just prevEdges) survives patchwork refetches, which
                    // transiently empty the edge list and would otherwise drop the flag
                    selected: selectedEdgeIds.includes(id) ||
                        ((selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.type) === 'edge' && selectedEntity.id === id), style: {
                        stroke: '#4CAF50',
                        strokeWidth: 4,
                    }, markerEnd: {
                        type: 'arrowclosed',
                        color: '#4CAF50',
                    } });
                // return decorateEdge(baseEdge, nodes);
            });
        });
    }, [patchwork.edges, setEdges, selectedEntity]);
    var decorateEdge = function (edge, nodes) {
        var _a, _b;
        var sourceType = (_a = nodes.find(function (n) { return n.id === edge.source; })) === null || _a === void 0 ? void 0 : _a.type;
        var targetType = (_b = nodes.find(function (n) { return n.id === edge.target; })) === null || _b === void 0 ? void 0 : _b.type;
        var color = NAVIGATION_NODES.has(sourceType) && NAVIGATION_NODES.has(targetType)
            ? '#2196F3'
            : '#4CAF50';
        return __assign(__assign({}, edge), { style: {
                stroke: color,
                strokeWidth: 4,
            }, markerEnd: {
                type: 'arrowclosed',
                color: color,
            } });
    };
    var onNodesChange = useCallback(function (changes) {
        var movedBatch = {};
        setNodes(function (nds) {
            var updatedNodes = applyNodeChanges(changes, nds);
            changes.forEach(function (c) {
                if (c.type === 'position' && c.dragging === false) {
                    var node = updatedNodes.find(function (n) { return n.id === c.id; });
                    if (!node)
                        return;
                    movedBatch[node.id] = [
                        Math.round(node.position.x),
                        Math.round(node.position.y),
                    ];
                }
            });
            return updatedNodes;
        });
    }, [setNodes]);
    var dragStartPos = useRef({});
    var onNodeDragStart = function (event, node) {
        dragStartPos.current[node.id] = {
            x: Math.round(node.position.x),
            y: Math.round(node.position.y),
        };
    };
    var onNodeDragStop = function (event, node) {
        var _a;
        var start = dragStartPos.current[node.id];
        if (!start)
            return;
        var endX = Math.round(node.position.x);
        var endY = Math.round(node.position.y);
        if (start.x !== endX || start.y !== endY) {
            onChangePatchCoordinates((_a = {},
                _a[node.id] = [endX, endY],
                _a));
        }
        delete dragStartPos.current[node.id];
    };
    // Edge Callbacks
    var onEdgeClick = useCallback(function (event, edge) {
        if (edge === null || edge === void 0 ? void 0 : edge.id) {
            // ReactFlow selection must follow `selectedEntity` here: if nodes stay
            // selected after an edge click, selectedPatches goes stale and a later
            // Delete targets the wrong entity (Sentry CMS-6TT)
            setNodes(deselectAllNodes);
            setEdges(function (eds) { return selectOnlyEdge(eds, edge.id); });
            setSelectedPatches([]);
            setSelectedEdges([edge.id]);
            onEdgeSelected({
                id: edge.id,
                from_patch: edge.source,
                to_patch: edge.target,
                from_arg: edge.sourceHandle,
                to_arg: edge.targetHandle,
            });
        }
    }, [onEdgeSelected, setNodes, setEdges]);
    var onEdgesChange = useCallback(function (changes) {
        onEdgesChangeBase(changes);
    }, [onEdgesChangeBase]);
    var onConnectStart = useCallback(function (event, _a) {
        var nodeId = _a.nodeId, handleType = _a.handleType, handleId = _a.handleId;
        connectionDetails.current = { nodeId: nodeId, handleType: handleType, handleId: handleId };
    }, []);
    var onConnect = useCallback(function (params) {
        onEdgeAdded === null || onEdgeAdded === void 0 ? void 0 : onEdgeAdded({
            from_patch: params.source,
            to_patch: params.target,
            from_arg: params.sourceHandle,
            to_arg: params.targetHandle,
        });
        setEdges(function (eds) { return addEdge(params, eds); });
    }, [onEdgeAdded, setEdges]);
    var onConnectEnd = useCallback(function (event) {
        var _a, _b, _c;
        var details = connectionDetails.current;
        if (!details)
            return;
        var target = event.target;
        // If dropped on a node or handle → real edge, do nothing
        if ((target === null || target === void 0 ? void 0 : target.closest('.react-flow__node')) ||
            ((_a = target === null || target === void 0 ? void 0 : target.classList) === null || _a === void 0 ? void 0 : _a.contains('react-flow__handle'))) {
            return;
        }
        // Otherwise → empty space → show modal
        var clientX = 'changedTouches' in event && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b[0])
            ? event.changedTouches[0].clientX
            : event.clientX;
        var clientY = 'changedTouches' in event && ((_c = event.changedTouches) === null || _c === void 0 ? void 0 : _c[0])
            ? event.changedTouches[0].clientY
            : event.clientY;
        var flowPosition = screenToFlowPosition({
            x: clientX,
            y: clientY,
        });
        var modalPosition = getModalPosition(clientX, clientY);
        dispatch(setCareerSourceAction(details.nodeId, details.nodeId, details.handleId, flowPosition));
        dispatch(updateModalPosition(modalPosition));
        dispatch(changeAddPatchModalState(true));
    }, [screenToFlowPosition, dispatch]);
    var onPaneMouseMove = useCallback(function (event) {
        var flowPos = screenToFlowPosition({
            x: event.clientX,
            y: event.clientY,
        });
        onCursorPosition(flowPos.x, flowPos.y);
    }, [onCursorPosition, screenToFlowPosition]);
    var handleKeyDown = useCallback(function (event) {
        var target = event.target;
        var isTyping = target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable;
        if (isTyping)
            return;
        var isCopyShortcut = (event.metaKey || event.ctrlKey) && event.key === 'c';
        var isPasteShortcut = (event.metaKey || event.ctrlKey) && event.key === 'v';
        var isDeleteKey = event.key === 'Delete' || event.key === 'Backspace';
        var isFindKey = (event.metaKey || event.ctrlKey) && event.key === 'f';
        if (isFindKey) {
            event.preventDefault();
            dispatch(changeSearchPatchState(true));
        }
        if (isCopyShortcut) {
            event.preventDefault();
            if (selectedPatches.length) {
                onCopy(selectedPatches);
                return;
            }
        }
        if (isPasteShortcut) {
            event.preventDefault();
            if (!isReadOnlyCanvas(permissions)) {
                onPaste();
            }
        }
        if (isDeleteKey && (selectedPatches.length || selectedEdges.length)) {
            event.preventDefault();
            dispatch(setDeleteConfirmationState(true));
        }
    }, [
        selectedPatches,
        selectedEdges.length,
        dispatch,
        onCopy,
        permissions,
        onPaste,
    ]);
    // Attach the keydown listener to the window when the component mounts.
    // isFocused is false while a nested route (e.g. /views/:id) is showing —
    // this page is mounted at the base "exact" url and never unmounts across
    // those routes, so without this check shortcuts (like cmd+f reopening the
    // search modal) would leak into unrelated pages.
    useEffect(function () {
        if (!isGraphActive || !isFocused)
            return;
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown, isGraphActive, isFocused]);
    // These modals render via a portal outside reactFlowWrapper, so opening one
    // fires onMouseLeave/onBlur on the wrapper. Closing it doesn't fire a
    // matching onMouseEnter since the cursor never actually moves, which left
    // isGraphActive stuck false (and shortcuts dead) until the user moved their
    // mouse out of and back into the browser window. Restore it explicitly.
    var wasModalOpenRef = useRef(false);
    useEffect(function () {
        var isAnyModalOpen = isDeleteConfirmationOpen || isModalOpen || isSearchModalOpen;
        if (wasModalOpenRef.current && !isAnyModalOpen) {
            setIsGraphActive(true);
        }
        wasModalOpenRef.current = isAnyModalOpen;
    }, [isDeleteConfirmationOpen, isModalOpen, isSearchModalOpen]);
    // This page never unmounts on navigation, so these portal-rendered modals
    // stay open above whatever page the user navigates to unless we close them
    // explicitly on route change.
    useCloseOnRouteChange(isSearchModalOpen, function () {
        dispatch(changeSearchPatchState(false));
        dispatch(changeFilterPopUpState(false));
        dispatch(updateModalPosition(null));
        setMatchingPatch({ label: '', value: '' });
    });
    useCloseOnRouteChange(isDeleteConfirmationOpen, function () {
        dispatch(setDeleteConfirmationState(false));
    });
    useCloseOnRouteChange(isModalOpen, function () {
        dispatch(changeCreateCustomLogicModalState(false));
    });
    var _k = useState(null), contextMenu = _k[0], setContextMenu = _k[1];
    var onNodeContextMenu = function (event, node) {
        event.preventDefault();
        event.stopPropagation();
        setContextMenu({
            x: event.pageX,
            y: event.pageY,
            node: node,
        });
    };
    var handleSelectMatch = function (_a) {
        var label = _a.label, value = _a.value;
        if (value && label) {
            setMatchingPatch({ label: label, value: value });
        }
        else {
            setMatchingPatch({ label: '', value: '' });
        }
    };
    var focusOnPatch = useCallback(function (patchId) {
        var selectedPatch = patchwork.allPatches.find(function (patch) { return patch.id === patchId; });
        if (!selectedPatch)
            return false;
        setNodes(function (prev) {
            return prev.map(function (node) { return (__assign(__assign({}, node), { selected: node.id === selectedPatch.id })); });
        });
        if (selectedPatch.type !== 'logic_group') {
            onPatchSelected(selectedPatch);
        }
        else {
            onDeselect();
        }
        var entryNode = nodes.find(function (n) { return n.id === selectedPatch.id; });
        if (entryNode) {
            fitView({
                nodes: [entryNode],
                padding: 3,
                duration: 300,
            });
        }
        return true;
    }, [
        patchwork.allPatches,
        setNodes,
        onPatchSelected,
        onDeselect,
        nodes,
        fitView,
    ]);
    // Mirrors onEdgeClick's selection, but driven by an id lookup instead of a
    // ReactFlow click event.
    var focusOnEdge = useCallback(function (edgeId) {
        var targetEdge = edges.find(function (e) { return e.id === edgeId; });
        if (!targetEdge)
            return false;
        setNodes(deselectAllNodes);
        setEdges(function (eds) { return selectOnlyEdge(eds, edgeId); });
        setSelectedPatches([]);
        setSelectedEdges([edgeId]);
        onEdgeSelected({
            id: targetEdge.id,
            from_patch: targetEdge.source,
            to_patch: targetEdge.target,
            from_arg: targetEdge.sourceHandle,
            to_arg: targetEdge.targetHandle,
        });
        var endpointNodes = nodes.filter(function (n) { return n.id === targetEdge.source || n.id === targetEdge.target; });
        if (endpointNodes.length) {
            fitView({
                nodes: endpointNodes,
                padding: 3,
                duration: 300,
            });
        }
        return true;
    }, [edges, nodes, setNodes, setEdges, onEdgeSelected, fitView]);
    var onSearchResultClick = function (result) {
        return (result === null || result === void 0 ? void 0 : result.value) && focusOnPatch(result.value);
    };
    // Selects and centers the patch or edge named in the URL
    // (e.g. .../structure/<patchId or edgeId>). Waits until the target shows up
    // in the ReactFlow nodes/edges state (populated async from patchwork).
    useEffect(function () {
        if (!focusEntityId || lastFocusedEntityId.current === focusEntityId) {
            return;
        }
        var targetIsNode = nodes.some(function (n) { return n.id === focusEntityId; });
        var targetIsEdge = edges.some(function (e) { return e.id === focusEntityId; });
        if (!targetIsNode && !targetIsEdge)
            return;
        lastFocusedEntityId.current = focusEntityId;
        targetIsNode ? focusOnPatch(focusEntityId) : focusOnEdge(focusEntityId);
    }, [focusEntityId, nodes, edges, focusOnPatch, focusOnEdge]);
    return (_jsx("div", __assign({ ref: reactFlowWrapper, style: { width: '100%', height: '100vh' }, onMouseEnter: function () { return setIsGraphActive(true); }, onMouseLeave: function () { return setIsGraphActive(false); }, onBlur: function (event) {
            // onBlur (focusout) bubbles from any descendant losing focus, even
            // when the newly-focused element is another node still inside this
            // wrapper (e.g. clicking between PatchWidgets), or when focus moves
            // to a non-focusable area (relatedTarget is then null in most
            // browsers) while the mouse never leaves the graph. Only treat it as
            // "left the graph" when focus demonstrably moved outside the
            // wrapper subtree.
            if (!event.relatedTarget ||
                event.currentTarget.contains(event.relatedTarget)) {
                return;
            }
            setIsGraphActive(false);
        } }, { children: _jsxs(ReactFlow, __assign({ panOnDrag: true, zoomOnPinch: true, zoomOnScroll: true, panOnScroll: false, preventScrolling: true, wheelSensitivity: 1.5, zoomActivationKeyCode: null, panActivationKeyCode: null, minZoom: 0.1, maxZoom: 4, nodeOrigin: [0, 0], nodes: nodes, edges: edges, nodeTypes: nodeTypes, onNodesChange: onNodesChange, onNodeDragStart: onNodeDragStart, onNodeDragStop: onNodeDragStop, onEdgeClick: onEdgeClick, onEdgesChange: onEdgesChange, onConnectStart: onConnectStart, onConnect: onConnect, onConnectEnd: onConnectEnd, onNodeContextMenu: onNodeContextMenu, onPaneContextMenu: function () { return setContextMenu(null); }, multiSelectionKeyCode: ['Meta', 'Shift'], deleteKeyCode: null, onPaneMouseMove: onPaneMouseMove, onPaneClick: function () {
                setContextMenu(null);
                onDeselect();
            } }, { children: [_jsx(FloatingMenu, { permissions: (_b = permissions === null || permissions === void 0 ? void 0 : permissions["app:".concat(appId, ":patchwork")]) !== null && _b !== void 0 ? _b : [], onRefreshPatchwork: onRefreshPatchwork, onFindHome: function () {
                        return onSearchResultClick({ value: patchwork.entrypoint });
                    }, isSB: true }), _jsx(ShortCutButton, {}), isDeleteConfirmationOpen && (_jsx(DeleteConfirmationModal, { active: isDeleteConfirmationOpen, selectedEntities: selectedPatches.length ? selectedPatches : selectedEdges, isPatchDeletion: selectedPatches.length, onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var edgeTobeDeleted;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(selectedPatches === null || selectedPatches === void 0 ? void 0 : selectedPatches.length)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, onPatchDelete(selectedPatches)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (!(selectedEdges === null || selectedEdges === void 0 ? void 0 : selectedEdges.length)) return [3 /*break*/, 4];
                                    edgeTobeDeleted = edges.find(function (edge) { return edge.id === selectedEdges[0]; });
                                    if (!edgeTobeDeleted) return [3 /*break*/, 4];
                                    return [4 /*yield*/, (onEdgeDelete === null || onEdgeDelete === void 0 ? void 0 : onEdgeDelete(__assign({ id: edgeTobeDeleted.id, from_patch: edgeTobeDeleted.source, to_patch: edgeTobeDeleted.target }, edgeTobeDeleted)))];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    dispatch(setDeleteConfirmationState(false));
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onCancel: function () {
                        dispatch(setDeleteConfirmationState(false));
                    }, pushTemplates: pushTemplates, patchesConnectedToHome: patchesConnectedToHome })), contextMenu && (_jsx(ContextMenu, { isOpen: !!contextMenu, onCreateCustomLogic: function () {
                        return dispatch(changeCreateCustomLogicModalState(true));
                    }, onCopy: onCopy, onPaste: onPaste, position: contextMenu, patchwork: patchwork, groupIds: selectedPatches
                        .filter(function (p) { return p.type === 'logic_group'; })
                        .map(function (sp) { return sp.data.patch.id; }), openGroup: openGroup })), isModalOpen && (_jsx(CreateCustomLogicModal, { nodes: nodes, selectedPatches: selectedPatches, patchwork: patchwork, onConfirm: onCreateCustomLogicPatchWithLogicPatches })), _jsx(SearchModal, { patchwork: patchwork, patchFilter: groupSelected ? ['logic', 'integration'] : [], handleSelectMatch: handleSelectMatch, selectedMatch: matchingPatch, onSearchResultClick: onSearchResultClick, isSB: true }), _jsx(ShortCutModal, {}), _jsx(Background, { color: "#aaa", gap: 16 })] })) })));
};
export default PatchworkGraph;
